import { ViteSSG } from 'vite-ssg'
import { createPinia } from 'pinia'
import { START_LOCATION } from 'vue-router'
import App from './App.vue'
import { routes } from './router'
import { resolvePath } from './content'
import './styles/fonts.css'
import './styles/main.css'

// Pages qui rendent du content_html en v-html : leur HTML n'est disponible cote client
// que via l'etat serialise de la page rendue. Une navigation SPA vers l'une d'elles doit
// donc se faire en rechargement plein (le HTML statique existe pour chaque URL).
const CONTENT_KINDS = new Set(['service', 'article', 'qui-sommes-nous', 'mentions'])

export const createApp = ViteSSG(
  App,
  {
    routes,
    scrollBehavior(to, _from, saved) {
      if (saved) return saved
      if (to.hash) return { el: to.hash, top: 90 }
      return { top: 0 }
    },
  },
  ({ app, router, initialState }) => {
    const pinia = createPinia()
    app.use(pinia)

    if (import.meta.env.SSR) {
      initialState.pinia = pinia.state.value
    } else if (initialState.pinia) {
      pinia.state.value = initialState.pinia
    }

    if (!import.meta.env.SSR) {
      router.beforeEach((to, from) => {
        if (from === START_LOCATION) return true
        if (CONTENT_KINDS.has(resolvePath(to.path).kind)) {
          window.location.assign(to.fullPath)
          return false
        }
        return true
      })
    }
  },
)
